// Finding a relation member's feature and what to highlight of it. Pure: sources are
// anything with getFeatureById, features anything with getGeometry.

/**
 * The relation's own source first (a relation layer's response carries its members'
 * parent ways and nodes), then the other visible vector sources. A feature without
 * geometry counts as not found.
 * @param {string} id
 * @param {{getFeatureById(id: string): unknown}|null} ownSource
 * @param {{source: {getFeatureById(id: string): unknown}, visible: boolean}[]} otherSources
 */
export function findMemberFeature(id, ownSource, otherSources) {
  const usable = (feature) =>
    feature && feature.getGeometry() ? feature : undefined;
  const own = ownSource ? usable(ownSource.getFeatureById(id)) : undefined;
  if (own) return own;
  for (const { source, visible } of otherSources) {
    if (!visible) continue;
    const found = usable(source.getFeatureById(id));
    if (found) return found;
  }
  return undefined;
}

/**
 * @param {{lr: {type: string, startCm: number, endCm: number|null}|null}} member
 * @param {number|null} lengthCm the member feature's length
 * @returns {{kind: "whole"}|
 *   {kind: "range", ranges: {startCm: number, endCm: number|null}[]}|
 *   {kind: "spot", fraction: number}} a multi-range role keeps every range
 */
export function memberHighlightPlan(member, lengthCm) {
  const lr = member.lr;
  if (!lr) return { kind: "whole" };
  if (lr.type === "spot") {
    if (!(lengthCm > 0)) return { kind: "whole" };
    return {
      kind: "spot",
      fraction: Math.min(Math.max(lr.startCm / lengthCm, 0), 1),
    };
  }
  const ranges = lr.ranges ?? [{ startCm: lr.startCm, endCm: lr.endCm }];
  return { kind: "range", ranges };
}
